<template>
  <div id="chart"></div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      items: null,
      scripts: [
        {
          url: 'https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.6/d3.min.js'
        },
        {
          url: 'https://cdnjs.cloudflare.com/ajax/libs/stats.js/r14/Stats.js'
        },
        {
          url: 'http://d3js.org/queue.v1.min.js'
        },
        {
          url: 'http://ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js'
        },
        {
          url: '/static/graph/circles.js'
        }
      ]
    }
  },
  created () {
    this.fetchItems()
  },
  mounted () {
    this.scripts.forEach(function (script) {
      let load = document.createElement('script')
      load.setAttribute('src', script.url)
      document.head.appendChild(load)
    })
  },
  methods: {
    fetchItems () {
      axios
        .get('http://localhost:8080/static/graph/items.json')
        // .get(`${process.env.ROOT_API}/storage/browser/items.json`)
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          console.log(error)
        });
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/graph/Circles.vue